<template>
  <div class="lang-container">
    <b-dropdown
      id="lang-dropdown"
      right
      variant="outline-primary"
      toggle-class="text-decoration-none"
      size="sm"
    >
      <template #button-content>
        <div style="display: flex;">
          <img
            :src="selectedLanguage.svgSrc"
            alt="lng-icon"
          >
          <span class="lng-code">
            {{ selectedLanguage.code }}
          </span>
          <ArrowDownIcon class="arrow-icon" />
        </div>
      </template>
      <b-dropdown-item
        v-for="language in supportedLanguages"
        :key="language.code"
        @click="changeLanguage(language.code)"
      >
        <img
          :src="language.svgSrc"
          alt="language-icon"
          class="dropdown-item-icon"
        >
        {{ language.title }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { SUPPORTED_LANGUAGES, LANGUAGE_TITLES } from '../../../../constants';
import ArrowDownIcon from '../assets/icons/iconsCode/arrow-down';
import de from '../assets/icons/flags/de.svg';
import en from '../assets/icons/flags/en.svg';

export default {
  name: 'Language',
  components: { ArrowDownIcon },
  data: function() {
    return {
      supportedLanguages: [],
      selectedLanguage: null,
      flagIcons: {
        de,
        en
      }
    };
  },
  created() {
    this.supportedLanguages = SUPPORTED_LANGUAGES.map(
      (code) => ({ code, title: LANGUAGE_TITLES[code], svgSrc: this.flagIcons[code] }),
    );
    this.selectedLanguage = this.supportedLanguages.find(l => l.code === this.lng);
  },
  methods: {
    changeLanguage: function(languageCode) {
      this.$changeLanguage(languageCode);
    }
  }
};
</script>

<style scoped lang="scss">
.lang-container {
  margin-right: 20px;
}

.flag {
  height: 24px;
  width: 24px;
  margin-right: 10px;
}

::v-deep .dropdown-item {
  font-size: 0.875rem;
}
::v-deep .show > .dropdown-toggle {
  background: inherit;
}
::v-deep .dropdown-toggle {
  padding: 5px;
  border: none;

  img {
    width: 20px;
    height: auto;
    margin-right: 5px;
  }
  &::after {
    display: none;
  }
  &:hover,
  &:focus,
  &:active {
    border: none!important;
  }
}
.lng-code {
  text-transform: uppercase;
  display: inline-block;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #646A87;
}
.arrow-icon {
  width: 8px;
  margin-left: 5px;
  color: #646A87;
}
.dropdown-item-icon {
  margin-right: 5px;
  width: 25px;
}
</style>
